(() => {
  const init = root => {
    if (!root || root.dataset.otaReady) return;
    root.dataset.otaReady = 'true';
    const toc = root.querySelector('.rk-ota-toc');
    const groups = [...root.querySelectorAll('.rk-ota-release')];
    const list = toc.querySelector('ol');
    groups.forEach((group, i) => {
      if (!group.id) group.id = `ota-version-${i + 1}`;
      const heading = group.querySelector('h2');
      if (!heading) return;
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${group.id}`;
      const name = document.createElement('span');
      name.className = 'rk-ota-toc-name';
      name.textContent = `${heading.textContent.trim().replace(/^Ver\.\s*/i, '').replace(/\s*リリースノート$/, '')} リリースノート`;
      heading.textContent = name.textContent;
      link.append(name);
      const sourceDate = group.querySelector('time');
      if (sourceDate) {
        const date = document.createElement('span');
        date.className = 'rk-ota-toc-date';
        date.textContent = `${sourceDate.textContent.trim().replace(/\./g, '/')} 更新`;
        link.append(date);
      }
      li.append(link); list.append(li);
    });
    if (list.children.length) toc.hidden = false;
    const mq = window.matchMedia('(max-width: 899px)');
    const more = toc.querySelector('.rk-ota-more');
    let expanded = false;
    toc.querySelector('details').open = true;
    const adapt = () => {
      const limited = mq.matches && list.children.length > 5;
      [...list.children].forEach((li, i) => { li.hidden = limited && !expanded && i >= 5; });
      more.hidden = !limited || expanded;
      more.setAttribute('aria-expanded', String(expanded));
      more.textContent = 'すべてのリリースノートを見る';
    };
    more.addEventListener('click', () => {
      expanded = true; adapt();
      list.children[5]?.querySelector('a').focus({ preventScroll: true });
    });
    adapt(); mq.addEventListener('change', adapt);
    const reveal = hash => {
      const target = groups.find(g => `#${g.id}` === hash);
      if (!target) return;
      target.open = true;
      if ([...list.children].findIndex(li => li.querySelector('a').hash === hash) >= 5) { expanded = true; adapt(); }
      list.querySelectorAll('a').forEach(a => {
        if (a.hash === hash) a.setAttribute('aria-current', 'location');
        else a.removeAttribute('aria-current');
      });
      requestAnimationFrame(() => {
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
        target.querySelector('summary').focus({ preventScroll: true });
      });
    };
    list.addEventListener('click', e => {
      const link = e.target.closest('a'); if (!link) return;
      e.preventDefault(); history.pushState(null, '', link.hash); reveal(link.hash);
    });
    window.addEventListener('hashchange', () => reveal(location.hash));
    if (location.hash) reveal(location.hash);
    const dialog = root.querySelector('dialog');
    let opener;
    root.querySelectorAll('.rk-ota-image').forEach(link => link.addEventListener('click', e => {
      if (!dialog.showModal || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault(); opener = link;
      const image = link.querySelector('img');
      dialog.querySelector('img').src = link.href;
      dialog.querySelector('img').alt = image.alt;
      dialog.querySelector('p').textContent = image.alt;
      dialog.showModal();
    }));
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
    dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
  };
  document.querySelectorAll('[data-ota-article]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-ota-article]').forEach(init));
})();
